var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-3"},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"300","type":"paragraph"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }